import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { useTranslation } from 'react-i18next';

import SwabRequestForm from '../forms/SwabRequestForm';
import Modal from './Modal';

const SwabRequest = ({ linkText, displayType, buttonColor, path }) => {
  const { t } = useTranslation();
  return (
    <Modal
      id="swab-request"
      label={linkText}
      type={displayType}
      color={buttonColor}
      width="1200px"
    >
      <SwabRequestForm
        path={path}
        onClose={() => {
          const event = new Event('closeModal');
          window.dispatchEvent(event);
        }}
        title={t('Contact Us to Order Test Swabs')}
        buttonText={t('Request Swabs')}
      />
    </Modal>
  );
};
export default DisplayComponent(SwabRequest);
